<template>
  <div class="chat-container c-main-shadow">
    <div class="c-flex">
      <chat v-if="showChat" :talkList="talkList" :singleScreen="isSingleScreen" class="s" ref="chat" />
      <talk-list v-if="showList" :talkList="talkList" :singleScreen="isSingleScreen" />
    </div>
  </div>
</template>

<script>
import talkList from './TalkList.vue';
import chat from './Chat.vue';
import store from '../../store';
import talkPlugin from '../../utils/plugin/talkPlugin';
import UTILS from '../../utils/utils';

export default {
  components: {
    'talk-list': talkList,
    chat: chat,
  },
  mixins: [talkPlugin],
  beforeRouteEnter(route, redirect, next) {
    if (route.name == 'topTalk') return next();
    next(vm => {
      vm.getTalkNameWithCb(store.state.talk.talk, name => {
        UTILS.setDocumentTitle(route, null, name);
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name == 'topTalk') return next();
    this.getTalkNameWithCb(store.state.talk.talk, name => {
      store.commit('PAGE_TITLE', name);
      next();
    });
  },
  computed: {
    isSingleScreen() {
      if (this.geMax) return false;
      else if (this.gePc) return true;
      else if (this.leSp) return true;
      else if (this.leTbS) return false;
      else if (this.leTb) return true;
      return true;
    },
    showChat() {
      return !this.isSingleScreen || this.$route.name == 'talkDetail';
    },
    showList() {
      return !this.isSingleScreen || this.$route.name != 'talkDetail';
    },
    talkList() {
      var l = this.$store.getters.sortedTalks;
      var cid = this.getRouteCid();
      return cid
        ? l.filter(data => {
            return data.cid == cid;
          })
        : l;
    },
  },
  methods: {
    getTalkNameWithCb(talk, cb) {
      if (!talk) return cb(null);
      if (this.curCid && talk.cid != this.curCid) {
        return this.$router.push({ name: 'topTalk', params: { id: this.curCid } });
      }
      var self = this;
      UTILS.getAllGroupsAndMembers(talk.cid, r => {
        cb(self.getTalkName(talk, r.cms));
      });
    },
  },
};
</script>

<style scoped>
.chat-container {
  min-height: calc(100vh - 160px);
  max-height: calc(100vh - 160px);
}
.le-tbs .chat-container {
  min-height: calc(100vh - 108px);
  max-height: calc(100vh - 108px);
}
</style>
